import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Youtube } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/lib/data";
import { LogoMark } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#050B1F] border-t border-white/10 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <LogoMark size={52} />
              <div>
                <div className="font-display font-black text-2xl">
                  BE EASY <span className="text-red-500">CARS</span>
                </div>
                <div className="text-xs uppercase tracking-[0.28em] text-slate-400 mt-1">
                  {BRAND.tagline}
                </div>
              </div>
            </div>
            <p className="text-slate-400 text-base leading-relaxed max-w-md">
              Maharashtra's trusted partner for T-Permit commercial vehicles.
              End-to-end solutions from sales and finance to permit, insurance
              and airport attachment.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 hover:bg-red-600 border border-white/10 flex items-center justify-center transition-colors" aria-label="Facebook" data-testid="footer-social-facebook">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 hover:bg-red-600 border border-white/10 flex items-center justify-center transition-colors" aria-label="Instagram" data-testid="footer-social-instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 hover:bg-red-600 border border-white/10 flex items-center justify-center transition-colors" aria-label="Youtube" data-testid="footer-social-youtube">
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-display font-bold text-sm uppercase tracking-[0.2em] text-slate-200 mb-5">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {NAV_LINKS.slice(0, 7).map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-slate-400 hover:text-red-500 transition-colors text-sm"
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-bold text-sm uppercase tracking-[0.2em] text-slate-200 mb-5">
              Contact
            </h4>
            <ul className="space-y-4 text-sm text-slate-400">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-red-500 shrink-0" />
                <span>{BRAND.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-red-500 shrink-0" />
                <a href={`tel:+91${BRAND.phone}`} className="hover:text-white transition-colors" data-testid="footer-phone">
                  {BRAND.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-red-500 shrink-0" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-white transition-colors break-all" data-testid="footer-email">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 mt-0.5 text-red-500 shrink-0" />
                <span>{BRAND.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Be Easy Cars. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">
            T-Permit Vehicle Solutions • Thane, Maharashtra
          </p>
        </div>
      </div>
    </footer>
  );
}
